<template>
	<div class="ModalEditApplication">
		<div
			class="modal-container"
			id="edit-application-modal"
			:style="{ zIndex: '9999999999' }"
		>
			<div
				class="modal-header"
				:style="{ borderBottom: `1px solid ${theme.mainTextColor}` }"
			>
				Please Explain This Change
			</div>
			<div class="modal-body">
				<InputTextbox
					v-model:saturn="reasonForEdit"
					:multiline="true"
				>
					<template #validation>
						<div></div>
					</template>
				</InputTextbox>
			</div>
			<div
				class="modal-footer"
				:style="{ borderTop: `1px solid ${theme.mainTextColor}` }"
			>
				<button
					class="button"
					:style="{
						background: theme.errorButtonColor,
						color: theme.errorButtonTextColor,
					}"
					@click="cancel()"
				>
					Cancel
				</button>
				<button
					class="button"
					:style="{
						background: theme.successButtonColor,
						color: theme.successButtonTextColor,
					}"
					@click="close()"
					:disabled="v$.$invalid"
				>
					Save
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	import $modal from '@core/services/modal';
	import ApplicationsSettingsLoader from '@core/classes/Applications/ApplicationsSettingsLoader';
	import InputTextbox from '@core/components/InputTextbox.vue';
	import { required } from '@vuelidate/validators';
	import { useVuelidate } from '@vuelidate/core';

	export default {
		name: 'modalEditApplication',
		props: ['modal'],
		setup() {
			return { v$: useVuelidate({ $scope: false }) };
		},
		data() {
			return {
				theme: null,
				reasonForEdit: null,
			};
		},
		computed: {},
		created() {
			this.theme = ApplicationsSettingsLoader.ApplicationSettings.theme;
		},
		validations() {
			let validations = {
				reasonForEdit: { required },
			};

			return validations;
		},
		methods: {
			close() {
				const changeLog = {
					modificationTimestamp: new Date(),
					questionKey: this.modal.passedData.key,
					previousValue: this.modal.passedData.savedAnswer,
					newValue: this.modal.passedData.newValue,
					changeExplanation: this.reasonForEdit,
				};
				console.log('changeLog', changeLog);
				this.modal.passedData.application.changeLogs.push(changeLog);
				console.log('ChangeLogs', this.modal.passedData.application.changeLogs);

				$modal.close();
			},
			cancel() {
				$modal.cancel();
			},
		},
		components: {
			InputTextbox,
		},
	};
</script>
<style>
	.ModalEditApplication {
		margin: auto;
		display: flex;
		justify-content: center;
		width: 100%;
		max-width: 300px;
		transition: max-width 1s ease;
	}

	.ModalEditApplication .modal-container#edit-application-modal {
		width: 90%;
	}

	.ModalEditApplication .modal-header {
		text-align: center;
		text-transform: capitalize;
		display: flex;
		justify-content: center;
	}

	.ModalEditApplication .modal-footer {
		justify-content: space-between;
	}

	.ModalEditApplication .modal-footer .button {
		padding: 5px 10px;
		min-width: 40%;
	}

	.ModalEditApplication .modal-body .input-component {
		border-bottom: none;
		border-bottom-style: unset;
	}

	.ModalEditApplication textarea {
		width: 100%;
		height: 100px;
		padding: 5px 5px 5px 10px;
		transition: height 1s ease;
	}

	@media screen and (min-width: 280px) {
		.ModalEditApplication .modal-footer .button {
			padding: 10px 20px;
			min-width: 100px;
		}
	}

	@media screen and (min-width: 375px) {
		.ModalEditApplication {
			max-width: 400px;
		}
		.ModalEditApplication .modal-footer {
			justify-content: space-evenly;
		}
	}

	@media screen and (min-width: 768px) {
		.ModalEditApplication {
			max-width: 500px;
		}
		.ModalEditApplication .modal-footer .button {
			padding: 15px 30px;
		}
		.ModalEditApplication textarea {
			width: 100%;
			height: 150px;
		}
	}
</style>
